import * as yup from "yup";
import { FormInputMeta } from "@Modules/core/types/FormMetaType";
import { getValidationSchema } from "@Shared/utils/validationSchema";
import { CorporateNameInputMeta } from "@Shared/containers/form/commonMeta";

export interface ICardConsultationFormMeta {
    bank: FormInputMeta;
    customer: FormInputMeta;
    pan: FormInputMeta;
    firstName: FormInputMeta;
    name2: FormInputMeta;
    name: FormInputMeta;
    dateFrom: FormInputMeta;
    dateTo: FormInputMeta;
    chip: FormInputMeta;
    mag: FormInputMeta;

    schema: any;
}

const cardConsultationFormMeta = {} as ICardConsultationFormMeta;

cardConsultationFormMeta.bank = {
    ...CorporateNameInputMeta,
    name: "bank",
    type: "select",
    label: "Banque",
};

cardConsultationFormMeta.customer = {
    name: "customer",
    type: "select",
    label: "Client",
    placeholder: "",
    validation: yup.string(),
};

cardConsultationFormMeta.pan = {
    name: "pan",
    type: "select",
    label: "PAN",
    placeholder: "",
    validation: yup.string(),
};

cardConsultationFormMeta.firstName = {
    name: "firstName",
    type: "text",
    label: "Prénom",
    placeholder: "",
    validation: yup.string(),
};

cardConsultationFormMeta.name2 = {
    name: "name2",
    type: "text",
    label: "Nom 2",
    placeholder: "",
    validation: yup.string(),
};

cardConsultationFormMeta.name = {
    name: "name",
    type: "text",
    label: "Nom",
    placeholder: "",
    validation: yup.string(),
};

cardConsultationFormMeta.dateFrom = {
    name: "dateFrom",
    type: "date",
    label: "Date Du",
    placeholder: "",
    validation: yup.date().notRequired(),
};

cardConsultationFormMeta.dateTo = {
    name: "dateTo",
    type: "date",
    label: "Au",
    placeholder: "",
    validation: yup.date().notRequired(),
};

cardConsultationFormMeta.chip = {
    name: "chip",
    type: "checkbox",
    label: "Puce",
    placeholder: "",
    validation: yup.boolean().notRequired(),
};

cardConsultationFormMeta.mag = {
    name: "mag",
    type: "checkbox",
    label: "Mag",
    placeholder: "",
    validation: yup.boolean().notRequired(),
};


cardConsultationFormMeta.schema = yup.object().shape(getValidationSchema(cardConsultationFormMeta));

export default cardConsultationFormMeta;